import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import Layout from './core/Layout';
import PrimeReact from 'primereact/api';
import {
  HashRouter as Router
} from "react-router-dom";

PrimeReact.ripple = true;

function App() {

  return (
    <Router>
      <div className="App">
        <Layout/>
      </div>
    </Router>
  );
}

export default App;